export function isDiagnosisIntent(intent) {
  return String(intent?.action || '').toLowerCase().includes('diagnose');
}

/** Diagnosis: Good Choice, otherwise Poor Choice. Other intents: stored evaluation as-is. */
export function getIntentEvaluationForDisplay(intent) {
  const evaluation = String(intent?.evaluation || '').trim();
  if (isDiagnosisIntent(intent)) {
    return evaluation.toLowerCase() === 'good choice' ? 'Good Choice' : 'Poor Choice';
  }
  return evaluation;
}

export function shouldShowIntentResult(intent) {
  const result = String(intent?.result || '').trim();
  if (!result) return false;
  if (isDiagnosisIntent(intent)) return false;
  if (/^(correct|incorrect)$/i.test(result)) return false;
  return true;
}

/** Whether intent detail panels should show persona/evaluation content. */
export function intentHasPersonaResultForDisplay(intent) {
  if (intent?.hasPersonaResult || intent?.isStateTransition) return true;
  if (String(intent?.evaluation || '').trim()) return true;
  return isDiagnosisIntent(intent);
}

export function getEvaluationMuiColor(evaluation) {
  const value = String(evaluation || '').toLowerCase();
  if (
    value.includes('critical') ||
    value.includes('recomm') ||
    value.includes('good choice') ||
    value.includes('correct')
  ) {
    return 'success.main';
  }
  if (value.includes('neutral')) return 'info.main';
  if (value.includes('unnecessary')) return 'warning.main';
  return 'error.main';
}
